import { dashboard } from 'types';
import { minBy } from 'es-toolkit/compat';

export function mostDesirableOverbookingType(
  ...types: Array<dashboard.OverbookingType | null | undefined>
): dashboard.OverbookingType {
  return (
    minBy(types, (t) => (t ? overbookingTypeToEnumValue[t] : DEFAULT_OVERBOOKING_TYPE)) ??
    DEFAULT_OVERBOOKING_TYPE
  );
}

const DEFAULT_OVERBOOKING_TYPE: dashboard.OverbookingType = 'NO_OVERBOOKING';

// Keep in sync with calendar.proto#OverbookingType
const overbookingTypeToEnumValue: Record<dashboard.OverbookingType, number> = {
  NO_OVERBOOKING: 0,
  TURN_TIME_CONFLICT: 1,
  HOLD_CONFLICT: 10,
  LOCK_CONFLICT: 20,
  PACE_BLOCKED: 25,
  BLOCK_CONFLICT: 30,
  PARTY_SIZE_CONFLICT: 35,
  EXPERIENCE_MISMATCH: 40,
  EXPERIENCE_BOOKABLE_RANGE_MISMATCH: 41,
};
